// extracted by mini-css-extract-plugin
export default {"container":"dP-z","topReviewHeading":"eP-z","criticalReview":"fP-z","favorableReview":"gP-z","vsSeparator":"hP-z"};